// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"b0080523","440":"651862e9","461":"ff03f605","613":"5ecebc54","869":"30a8f0a9"}[chunkId] + ".chunk.js";
};